import React from 'react'
import pickleballPlayPass from "../../../Asset/Membership/MembershipSchedule/pickleball-play-pass.svg"
import footballCheckboxWhite from "../../../Asset/Membership/MembershipSchedule/checkboxes/football-checkbox-white.svg"
import footballCheckboxPurple from "../../../Asset/Membership/MembershipSchedule/checkboxes/football-checkbox-purple.svg"
import padelCheckboxWhite from "../../../Asset/Membership/MembershipSchedule/checkboxes/padel-checkbox-white.svg"
import padelCheckboxPurple from "../../../Asset/Membership/MembershipSchedule/checkboxes/padel-checkbox-purple.svg"
import pickleballCheckboxWhite from "../../../Asset/Membership/MembershipSchedule/checkboxes/pickleball-checkbox-white.svg"
import pickleballCheckboxPurple from "../../../Asset/Membership/MembershipSchedule/checkboxes/pickleball-checkbox-purple.svg"
import bronzeCheckboxWhite from "../../../Asset/Membership/MembershipSchedule/checkboxes/bronze-checkbox-white.svg"
import bronzeCheckboxPurple from "../../../Asset/Membership/MembershipSchedule/checkboxes/bronze-checkbox-purple.svg"
import silverCheckboxWhite from "../../../Asset/Membership/MembershipSchedule/checkboxes/silver-checkbox-white.svg"
import silverCheckboxPurple from "../../../Asset/Membership/MembershipSchedule/checkboxes/silver-checkbox-purple.svg"
import goldCheckboxWhite from "../../../Asset/Membership/MembershipSchedule/checkboxes/gold-checkbox-white.svg"
import goldCheckboxPurple from "../../../Asset/Membership/MembershipSchedule/checkboxes/gold-checkbox-purple.svg"

// Function to highlight specific words in offering labels
const highlightSpecialWords = (text) => {
  const specialWords = ['PlayPass', 'Coaching', 'Bootcamp', 'Social', 'Event']
  const parts = text.split(' ')

  return parts.map((part, index) => {
    if (specialWords.includes(part)) {
      return <span key={index} style={{ color: '#512D9A' }}>{part}</span>
    }
    return part
  }).reduce((acc, curr, index) => {
    if (index === 0) return [curr]
    return [...acc, ' ', curr]
  }, [])
}

const MembershipScheduleSectionWeb = ({
  selectedSports,
  selectedTier,
  offerings,
  handleSportToggle,
  handleTierSelect,
  handleSeeOfferings,
  isFormValid,
  OFFERING_IMAGES,
  CREDIT_MAP
}) => {
  return (
    <div id="membership-schedule-white-box-container" className='bg-[var(--white)] flex flex-col md:flex-row px-10 md:pt-[4.5rem] md:pb-[5rem] mt-10 rounded-3xl gap-8'>

      {/* left side portion */}
      <div id="membership-schedule-left-side" className='w-full md:w-[43%] flex flex-col justify-between items-start font-ClashGrotesk text-[var(--dark-blue)] text-[2rem] font-[530]'>

        {/* top text */}
        <div>
          I want to play
        </div>

        {/* sports toggle buttons */}
        <div id="membership-schedule-sport-selector" className='flex gap-4  mb-2 '>
          {[
            {
              key: 'football',
              label: 'Football',
              whiteIcon: footballCheckboxWhite,
              purpleIcon: footballCheckboxPurple
            },
            {
              key: 'padel',
              label: 'Padel',
              whiteIcon: padelCheckboxWhite,
              purpleIcon: padelCheckboxPurple
            },
            {
              key: 'pickleball',
              label: 'Pickleball',
              whiteIcon: pickleballCheckboxWhite,
              purpleIcon: pickleballCheckboxPurple
            },
          ].map(sport => (
            <button
              key={sport.key}
              onClick={() => handleSportToggle(sport.key)}
              className='flex flex-col items-center gap-2  rounded-lg transition-all'
            >
              <img
                src={selectedSports[sport.key] ? sport.purpleIcon : sport.whiteIcon}
                alt={sport.label}
                className="w-36 h-36"
              />

            </button>
          ))}
        </div>

        <div className='md:mt-5 font-ClashGrotesk font-[520]'>
          with this tier membership
        </div>

        {/* tier selection buttons */}
        <div id="membership-schedule-tier-selector" className='flex gap-4'>
          {[
            {
              key: 'bronze',
              label: 'Bronze',
              whiteIcon: bronzeCheckboxWhite,
              purpleIcon: bronzeCheckboxPurple
            },
            {
              key: 'silver',
              label: 'Silver',
              whiteIcon: silverCheckboxWhite,
              purpleIcon: silverCheckboxPurple
            },
            {
              key: 'gold',
              label: 'Gold',
              whiteIcon: goldCheckboxWhite,
              purpleIcon: goldCheckboxPurple
            },
          ].map(tier => (
            <div
              key={tier.key}
              role="button"
              tabIndex={0}
              onClick={() => handleTierSelect(tier.key)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleTierSelect(tier.key); }}
              style={{
                WebkitTapHighlightColor: 'transparent',
                cursor: 'pointer',
                outline: 'none',
                userSelect: 'none'
              }}
              className="p-0 m-0 leading-[0]"
            >
              <img
                src={selectedTier === tier.key ? tier.purpleIcon : tier.whiteIcon}
                alt={tier.label}
                className="w-[145px] h-[65px] md:w-[155px] md:h-[70px] object-fill pointer-events-none"
              />
            </div>
          ))}
        </div>

        {/* bottom button */}
        <button
          onClick={handleSeeOfferings}
          disabled={!isFormValid}
          className={`font-manrope font-semibold text-[1.077rem] py-4 w-[65%] rounded-xl transition-all translate-y-8 ${isFormValid
            ? 'bg-[var(--button-green)] text-[var(--home-about-us-ptn-button-grey)] hover:opacity-90'
            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
        >
          See Offerings
        </button>

      </div>

      {/* right side portion */}
      <div id="membership-schedule-right-side" className='w-full md:w-[50%] flex flex-col'>
        {offerings.length === 0 ? (
          <div className="flex items-center justify-center h-64 text-gray-400 font-manrope">
            {Object.values(selectedSports).some(v => v) ? 'Select tier to preview offerings' : 'Choose a sport to see the offerings'}
          </div>
        ) : (
          <div id="offerings-scroll-container" className='flex flex-col gap-4 max-h-[28rem] overflow-y-auto pr-2'>
            {offerings.map((offering, idx) => {
              const hasImage = OFFERING_IMAGES[offering.label]
              const isGrayBackground = ['NG Social', 'NG Event', 'Coaching'].includes(offering.label)

              return (
                <div
                  key={idx}
                  className='relative w-full h-24 rounded-xl overflow-hidden animate-fadeIn flex-shrink-0'
                >
                  {hasImage ? (
                    <img
                      src={OFFERING_IMAGES[offering.label]}
                      alt={offering.label}
                      className='w-full h-full object-cover'
                    />
                  ) : (
                    <div className='w-full h-full' style={{ backgroundColor: '#F2F2F2' }} />
                  )}
                  <div id='text-on-offering-card' className='absolute inset-0 flex items-center justify-left px-6 text-white'>
                    <div className='w-[40%] flex items-center justify-center font-ClashGrotesk'>
                      <span className='font-manrope font-semibold text-xl text-[#707070]'>
                        {highlightSpecialWords(offering.label)} x {offering.count}
                      </span>
                    </div>
                    <div className='w-[40%] flex flex-col items-center justify-center font-manrope font-[700]'>
                      <span className='text-sm font-manrope text-[#707070] text-right'>
                        {offering.count * (CREDIT_MAP[offering.label] || 5)} Credits
                      </span>
                      <span className='text-[#512D9A]'>{CREDIT_MAP[offering.label] || 5} credits each</span>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>

    </div>
  )
}

export default MembershipScheduleSectionWeb
